import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Dummy component for rendering translations as *elements*. By default there are no translations.
 * Custom BlockTranslated is expected to be passed to the BlockComponentContext.
 */
export const Translated = ({ translationKey, render }) => (_jsx(_Fragment, { children: render ? render({ translation: translationKey }) : translationKey }));
/**
 * Dummy mapper for rendering translation as *strings*.
 */
export const translate = (translationKey) => translationKey;
